import React, { useEffect, useMemo, useState } from 'react';
import PopularVideoService from '../../../../services/onboarding-brightcove-video-service/popular-video-service';
import {
    DyfMoreWaysToLearnCards,
    DyfMoreWaysToLearnTitle,
} from './dyf-more-ways-to-learn-cards';
import './dyf-more-ways-to-learn.scss';
import {
    DyfMoreWaysToLearnGeneric,
    DyfMoreWaysToLearnGenericTitle,
} from './dyf-mwtl-generics';

export type MoreWaysToLearnView = 'related-articles' | 'article-overview';

interface Props {
    vehicleYear: string;
    baseRoot: string;
    renderView: MoreWaysToLearnView;
    vehicleYmmGroup: any;
    currentLanguageRegionCode: string;
}

async function fullRenderHtvDecider(props: Props): Promise<boolean> {
    const categoryVideos = await new PopularVideoService().getVideosByCategories(
        props.vehicleYear,
        props.vehicleYmmGroup.make,
        props.vehicleYmmGroup.marketName,
        props.currentLanguageRegionCode
    );

    const numCategories = Object.keys(categoryVideos).length;
    if (numCategories > 0) {
        return true;
    }
    return false;
}

export const DyfMoreWaysToLearn = (props: Props) => {
    const shouldRenderGeneric = useMemo(() => {
        return parseInt(props.vehicleYear, 10) <= 2022;
    }, [props.vehicleYear]);
    const [shouldRenderHtv, setHtvRender] = useState<boolean>(true);

    useEffect(() => {
        fullRenderHtvDecider(props)
            .then(res => setHtvRender(res))
            .catch(err => console.error({ err }));
    }, []);

    const moreWaysToLearnGenericContent = () => {
        return shouldRenderHtv ? (
            <div className="more-ways-to-learn-cards-section">
                <DyfMoreWaysToLearnGeneric
                    renderView={props.renderView}
                    year={props.vehicleYear}
                    model={props.vehicleYmmGroup.model}
                    baseRoot={props.baseRoot}
                    seoKey={props.vehicleYmmGroup.seoKey}
                    fullRenderHTV={true}
                />
            </div>
        ) : (
            <div className="more-ways-to-learn-duo-cards-section">
                <DyfMoreWaysToLearnGeneric
                    renderView={props.renderView}
                    year={props.vehicleYear}
                    model={props.vehicleYmmGroup.model}
                    baseRoot={props.baseRoot}
                    seoKey={props.vehicleYmmGroup.seoKey}
                    fullRenderHTV={false}
                />
            </div>
        );
    };

    const moreWaysToLearnCardsContent = () => {
        return shouldRenderHtv ? (
            <div className="more-ways-to-learn-cards-section">
                <DyfMoreWaysToLearnCards
                    vehicleYmmGroup={props.vehicleYmmGroup}
                    baseRoot={props.baseRoot}
                    renderView={props.renderView}
                    fullRenderHTV={true}
                />
            </div>
        ) : (
            <div className="more-ways-to-learn-duo-cards-section">
                <DyfMoreWaysToLearnCards
                    vehicleYmmGroup={props.vehicleYmmGroup}
                    baseRoot={props.baseRoot}
                    renderView={props.renderView}
                    fullRenderHTV={false}
                />
            </div>
        );
    };

    return (
        <section
            className="more-ways-to-learn"
            data-testid="more-ways-to-learn"
        >
            <div className="more-ways-to-learn-title-section">
                <h2
                    className="more-ways-to-learn-title"
                    data-testid="more-ways-to-learn-title"
                >
                    {' '}
                    {shouldRenderGeneric ? (
                        <DyfMoreWaysToLearnGenericTitle
                            renderView={props.renderView}
                        />
                    ) : (
                        <DyfMoreWaysToLearnTitle
                            vehicleYmmGroup={props.vehicleYmmGroup}
                            baseRoot={props.baseRoot}
                            renderView={props.renderView}
                            fullRenderHTV={shouldRenderHtv}
                        />
                    )}
                </h2>
            </div>
            {shouldRenderGeneric
                ? moreWaysToLearnGenericContent()
                : moreWaysToLearnCardsContent()}
        </section>
    );
};
